import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _templateObject;
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import { keyframes } from '@emotion/react';
import { ChildrenPropType } from '../../../../../../services/proptypes';
import { classNames } from '../../../../../../utils/classname';
import { DEFAULT_REVEAL_PROPS } from '../../../../reveal.constants';
import { BaseRevealOptionsPropTypes } from '../../../../types/reveal.types';
import Reveal from '../../Reveal';
import './FadeReveal.less';
var defaultProps = _objectSpread(_objectSpread({}, DEFAULT_REVEAL_PROPS), {}, {
  className: '',
  children: null,
  content: null
});
export default function FadeReveal(_ref) {
  var className = _ref.className,
    children = _ref.children,
    content = _ref.content,
    duration = _ref.duration,
    delay = _ref.delay,
    disableAnimation = _ref.disableAnimation,
    disableAnimationOnMobile = _ref.disableAnimationOnMobile,
    cascade = _ref.cascade,
    cascadeFactor = _ref.cascadeFactor,
    triggerOnce = _ref.triggerOnce,
    onVisibilityChange = _ref.onVisibilityChange,
    fraction = _ref.fraction,
    noContainer = _ref.noContainer;
  var finalClassName = classNames(_defineProperty({
    fade: true
  }, className, className));
  var opacityFrames = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    from {\n      opacity: 0;\n    }\n\n    to {\n      opacity: 1;\n    }\n"])));
  return /*#__PURE__*/React.createElement(Reveal, {
    content: content,
    className: finalClassName,
    duration: duration,
    delay: delay,
    disableAnimation: disableAnimation,
    disableAnimationOnMobile: disableAnimationOnMobile,
    cascade: cascade,
    cascadeFactor: cascadeFactor,
    triggerOnce: triggerOnce,
    onVisibilityChange: onVisibilityChange,
    keyFrames: opacityFrames,
    fraction: fraction,
    noContainer: noContainer
  }, children);
}
FadeReveal.defaultProps = defaultProps;